import { useProtrakApi } from '../../Core';

const typeBase = '/types';
export const CONFIG_TYPE = {
  CREATE: 'create',
  VIEW: 'view',
  EDIT: 'edit',
  DASHBOARD: 'dashboard',
  REPORT: 'report'
};

export const ATTRIBUTE_FIELD_TYPE_CONTRACT = {
  NAME: 'Name',
  RELATION_ATTRIBUTE: 'Relation Attribute',
  STATE: 'State',
  ATTRIBUTE: 'Attribute',
  PARENT: 'Parent',
  ACTIONS: 'Actions'
};

export function useTypeLayoutConfig(typeName, configType) {
  if (!typeName) {
    throw new Error('Invalid typeName passed');
  }
  if (!configType) {
    throw new Error('Invalid configType passed');
  }
  const endpoint = `${typeBase}/${typeName}/${configType}`;
  const { state } = useProtrakApi(
    { requestConfig: promiseFn, endpoint },
    { cacheKey: endpoint }
  );
  return state;
}

const promiseFn = ({ endpoint }) => {
  const cacheData = JSON.parse(window.localStorage.getItem(endpoint));
  return {
    endpoint: endpoint,
    config: {
      modified: cacheData ? cacheData.modified : null
    }
  };
};
